export default __webpack_public_path__ + "static/media/boiler.dc00f2fa.svg";